//GeneratorFlag:[NoChange]
import Pricing from './pricing';

export default {Pricing}
export{Pricing}